//src/services/adminUpload.api.js
const ADMIN_API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export const uploadAdminFile = async (file) => {
  const token = localStorage.getItem("adminToken");

  const form = new FormData();
  form.append("file", file);

  const res = await fetch(`${ADMIN_API_URL}/admin/upload`, {
    method: "POST",
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    body: form,
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error(data.message || "Upload failed");
  }

  return data; // { url, uuid }
};
